export default __webpack_public_path__ + "static/media/drag-drop-line.0ad43e48.svg";